export const Occupations = {
  "1": {
    FR: "Sans emploi",
    KEY: "1",
    EN: "Jobless",
  },
  "2": {
    FR: "Commerçant",
    KEY: "2",
    EN: "Merchant",
  },
  "3": {
    FR: "Etudiant/Elève",
    KEY: "3",
    EN: "Student/Pupil",
  },
  "4": {
    FR: "Employé",
    KEY: "4",
    EN: "Employee",
  },
  "5": {
    FR: "Fonctionnaire",
    KEY: "5",
    EN: "Civil servant",
  },
  "6": {
    FR: "Artiste/Liberal",
    KEY: "6",
    EN: "Artist/Liberal",
  },
  "7": {
    FR: "Athlète",
    KEY: "7",
    EN: "Sport staff",
  },
  "8": {
    FR: "Personnel Religieux",
    KEY: "8",
    EN: "Religious staff",
  },
  "9": {
    FR: "Police/Militaire",
    KEY: "9",
    EN: "Police/Military",
  },
  "10": {
    FR: "Politiciens/Officials",
    KEY: "10",
    EN: "Politicians/Officials",
  },
  "11": {
    FR: "Personnel mine/mining staff",
    KEY: "11",
    EN: "Personnel minier/mining staff",
  },
  "12": {
    FR: "Avocat/Judiciaire/Notaire",
    KEY: "12",
    EN: "Lawyer/Judicial Staff/Notaries",
  },
  "13": {
    FR: "Médecin/Infirmier",
    KEY: "13",
    EN: "Doctor/Nursing Staff",
  },
  "14": {
    FR: "Agent Immobilier/Réal Estate",
    KEY: "14",
    EN: "Real Estate Agent",
  },
  "15": {
    FR: "Comptable/auditeur",
    KEY: "15",
    EN: "Accountant/auditor",
  },
  "16": {
    FR: "Parieurs/joueurs",
    KEY: "15",
    EN: "Betters/casino gamblers",
  },
};
